export default {"src":"/_next/static/media/yardzen.45395b06.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};